export class PublishingHouseParent {
  constructor() {
    this.list = []
  }

  addPublishingHouse(item) {
    this.list.push(PublishingHouse.buildFromAPI(item))
  }

  updatePublishingHouse(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, PublishingHouse.buildFromAPI(item))
  }

  removePublishingHouse(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => PublishingHouse.buildFromAPI(el))
    }
    return this
  }
}

export class PublishingHouse {
  constructor() {
    this.id = null
    this.name = null
    this.place = null
    this.isActual = true
  }

  getForAPI() {
    return {
      id: this.id,
      name: this.name,
      place: this.place,
      isActual: this.isActual
    }
  }

  static buildFromAPI(obj) {
    const _this = new PublishingHouse()
    if (obj) {
      _this.id = obj.id
      _this.name = obj.name
      _this.place = obj.place
      _this.isActual = obj.id ? obj?.isActual : true
    }
    return _this
  }
}
